<template>
	<div class="content">
		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100">
				<md-card>
					<md-card-content>
						<loading v-if="!loaded" />
						<div class="md-layout" v-if="loaded">
							<div class="md-layout-item md-small-size-100 md-size-100">
								<h4>{{translate(locale.statistics)}}</h4>
							</div>

							<stat-card data-background-color="orange">
								<template slot="icon">pending_actions</template>
								<template slot="title">{{translate(locale.totalLog)}}</template>
								<template slot="value">{{overall.total_log}}</template>
							</stat-card>

							<stat-card data-background-color="orange">
								<template slot="icon">memory</template>
								<template slot="title">{{translate(locale.totalSystemClient)}}</template>
								<template slot="value">{{overall.total_system_client}}</template>
							</stat-card>

							<stat-card data-background-color="orange">
								<template slot="icon">supervised_user_circle</template>
								<template slot="title">{{translate(locale.totalUser)}}</template>
								<template slot="value">{{overall.total_user}}</template>
							</stat-card>

							<stat-card data-background-color="orange">
								<template slot="icon">settings</template>
								<template slot="title">{{translate(locale.totalSetting)}}</template>
								<template slot="value">{{overall.total_setting}}</template>
							</stat-card>
						</div>
					</md-card-content>
				</md-card>
			</div>

			<div class="md-layout-item md-medium-size-100 md-size-100">
				<md-card>
					<md-card-content>
						<loading v-if="!loaded" />
						<div class="md-layout" v-if="loaded">
							<div class="md-layout-item md-small-size-100 md-size-100">
								<h4>{{translate(locale.statisticsToday)}}</h4>
							</div>

							<stat-card data-background-color="orange">
								<template slot="icon">text_snippet</template>
								<template slot="title"><span style="color:green; font-size: 20px;">&#10687;</span> {{translate(locale.normalLog)}}</template>
								<template slot="value">{{today.total_normal_log}}</template>
							</stat-card>

							<stat-card data-background-color="orange">
								<template slot="icon">warning</template>
								<template slot="title"><span style="color:orange; font-size: 20px;">&#10687;</span> {{translate(locale.warningLog)}}</template>
								<template slot="value">{{today.total_warning_log}}</template>
							</stat-card>

							<stat-card data-background-color="orange">
								<template slot="icon">error</template>
								<template slot="title"><span style="color:red; font-size: 20px;">&#10687;</span> {{translate(locale.criticalLog)}}</template>
								<template slot="value">{{today.total_critical_log}}</template>
							</stat-card>

							<stat-card data-background-color="orange">
								<template slot="icon">pending_actions</template>
								<template slot="title">{{translate(locale.totalLog)}}</template>
								<template slot="value">{{today.total_log}}</template>
							</stat-card>

						</div>
					</md-card-content>
				</md-card>
			</div>

			<div class="md-layout-item md-medium-size-100 md-size-100">
				<md-card>
					<md-card-content>
						<loading v-if="!loaded" />
						<div class="md-layout" v-if="loaded">
							<div class="md-layout-item md-small-size-100 md-size-100">
								<h4>{{translate(locale.statisticsRange)}}</h4>
							</div>
							
							<div class="md-layout-item md-small-size-50 md-size-33">
								<md-field>
									<label>{{translate(locale.startDate)}}</label>
									<md-input type="text" v-model="search.start_date" style="display:none" />
									<datetime type="datetime" v-model="search.start_date" auto></datetime>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-33">
								<md-field>
									<label>{{translate(locale.endDate)}}</label>
									<md-input type="text" v-model="search.end_date" style="display:none" />
									<datetime type="datetime" v-model="search.end_date" auto></datetime>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-33">
								<md-button class="md-raised md-primary" @click="getRange()" style="width: 100%">{{translate(locale.search)}}</md-button>
							</div>

							<stat-card data-background-color="orange">
								<template slot="icon">text_snippet</template>
								<template slot="title"><span style="color:green; font-size: 20px;">&#10687;</span> {{translate(locale.normalLog)}}</template>
								<template slot="value">{{range.total_normal_log}}</template>
							</stat-card>

							<stat-card data-background-color="orange">
								<template slot="icon">warning</template>
								<template slot="title"><span style="color:orange; font-size: 20px;">&#10687;</span> {{translate(locale.warningLog)}}</template>
								<template slot="value">{{range.total_warning_log}}</template>
							</stat-card>

							<stat-card data-background-color="orange">
								<template slot="icon">error</template>
								<template slot="title"><span style="color:red; font-size: 20px;">&#10687;</span> {{translate(locale.criticalLog)}}</template>
								<template slot="value">{{range.total_critical_log}}</template>
							</stat-card>

							<stat-card data-background-color="orange">
								<template slot="icon">pending_actions</template>
								<template slot="title">{{translate(locale.totalLog)}}</template>
								<template slot="value">{{range.total_log}}</template>
							</stat-card>
						</div>
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>
</template>

<script>

	import { Datetime } from 'vue-datetime';
	import StatCard from '@/components/StatCard'
	export default {
		components: {
			StatCard,
			Datetime
		},
		created() {
			this.getStatistics();
		},
		data() {
			return {
				loaded: false,
				search: {
					start_date: "",
					end_date: ""
				},
				overall: {
					total_log: 0,
					total_system_client: 0,
					total_user: 0,
					total_setting: 0
				},
				today: {
					total_normal_log: 0,
					total_warning_log: 0,
					total_critical_log: 0,
					total_log: 0
				},
				range: {
					total_normal_log: 0,
					total_warning_log: 0,
					total_critical_log: 0,
					total_log: 0
				}
			}
		},
		methods: {
			getStatistics(more = false) {
				this.$http.get(this.config.api + "/admin/get/stat").then(data => {
					this.overall = data.body.data.overall;
					this.getToday();		
				})
			},
			getToday() {
				var date = new Date();
				var y = date.getFullYear(), m = date.getMonth(), d = date.getDate();

				var start_date = parseInt(((new Date(y, m, d, 0, 0, 0, 0)).getTime()));
				var end_date = parseInt(((new Date(y, m, d, 23, 59, 59, 999)).getTime()));

				this.$http.get(this.config.api + "/admin/get/stat/range/" + start_date + "/" + end_date).then(data => {
					this.today = data.body.data;
					this.loaded = true;
				});
			},
			getRange() {
				let start_date = (new Date(this.search.start_date)).getTime();
				let end_date = (new Date(this.search.end_date)).getTime();

				this.$http.get(this.config.api + "/admin/get/stat/range/" + start_date + "/" + end_date).then(data => {
					this.range = data.body.data
				});
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue